import { Component, inject } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { MachineDto } from 'src/app/shared/dtos/machine.dto';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, map } from 'rxjs';
import { SliderComponent } from 'src/app/shared/components/slider/slider.component';
import { RouterLink } from '@angular/router';
import { TemplateTypeDirective } from 'src/app/shared/directives/template-type.directive';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-recently-viewed',
  imports: [
    AsyncPipe,
    SliderComponent,
    RouterLink,
    TemplateTypeDirective,
    TranslocoPipe
  ],
  templateUrl: './recently-viewed.component.html',
  styleUrl: './recently-viewed.component.scss'
})
export class RecentlyViewedComponent {
  private readonly localStorageService = inject(LocalStorageService);
  
  protected readonly recentlyViewedItemTemplateType: { $implicit: MachineDto };

  private readonly refresh$ = new BehaviorSubject<null>(null);

  protected readonly recentlyViewedItems$ = this.refresh$.pipe(
    map(() => this.localStorageService.getItem<MachineDto[]>('recentlyViewedItems') ?? [])
  );

  protected clearAll(): void {
    this.localStorageService.removeItem('recentlyViewedItems');
    this.refresh$.next(null);
  }
}
